// MOIRÉ — Category Asset Library
// A curated, one-time-generated, statically cached premium editorial image set used
// ONLY as a fallback when no real user/wardrobe photo exists for a recommended piece.
//
// Visual hierarchy (enforced by callers):
//   1. User's actual uploaded photo        (item.image_url)
//   2. User's saved wardrobe/home photo     (item.image_url)
//   3. Closest realistic curated asset       -> assetForItem()
//   4. Premium neutral fallback / colour swatch
//
// Selection uses metadata: group/category + subcategory + colour family (+ material/style).
// Architected so individual assets can later be swapped for AI item-specific renders
// without touching the UI — just repoint a key in ASSET.

const BASE = "https://static.prod-images.emergentagent.com/jobs/546a136e-a670-42e5-9a92-188fbf299928/images/";
const u = (h) => `${BASE}${h}.jpeg`;

// Raw curated assets (one-time generated, ivory studio, editorial, colour-accurate)
export const ASSET = {
  // tops
  tshirt_white: u("dfa1e218a7c57bf186bf4a53c5ffc86ffc02c844e1f73cda706d3d04c60b0ca0"),
  shirt_white: u("0b49a05715ccd86f58c411a77c0c8df9a599a8393bb3e1de75508d2280edc70e"),
  oxford_blue: u("dc13e8f262285930f941d4b037fd59726ae916238d79c97b8ef74ffb584027ba"),
  polo_navy: u("cb21353361a15462cb6edae3c054cdf0ab8c89d3b11e3f99762bda750d3c3ff1"),
  blouse_ivory: u("5165a641fd772d3b540db340e7dcb3ce84b4b44cfd8e2dc0ad6fbd23f1a78401"),
  knit_beige: u("bba32ad981b11ffd75f7058928eb292347b2f7da0bebf907ff7d4e07f8e5c027"),
  // bottoms
  trousers_charcoal: u("08df678344885796e5ed26ed9da7790bec515a1e32e9b6b9b60cb72a1f758217"),
  chinos_beige: u("954eef019481ad87b85f7ea4dbfbb5898ef9611f1a43efe51a8d3cee1eb61419"),
  chinos_olive: u("a8805311304e6b5085ae549e6304e8c9f6dfe2818c128f07e4369596943ce42e"),
  jeans_blue: u("7e4e298bf2cd004b9a5907ae5f36b74dd29de99fbd1d554a8228701177c1e823"),
  cargo_khaki: u("d38571f5e8183eca25808e0a988ce53bf7cb632773222957b0a95075668846ec"),
  skirt_black: u("d97d97305fffd0a38999445a28de4dac821de5b2c18bed0ad0f1df0f10fc7a69"),
  shorts_stone: u("df5e040e400457c28c70c4bb2015646e15801b4cd187bb258c5d41878666b4c6"),
  // one-piece
  dress_black: u("c1bdcdb6d921f7ee0930e227444dc88f8db80aa91d82c6d232e331fb91fc8494"),
  jumpsuit_olive: u("403e9bfa0d51b0842b5b6d1e420aad4a52bb77de0b6e156b634e2bb091cc9646"),
  // outerwear
  blazer_navy: u("5f21157c3d4ec84154e19ab66c49c3675f3c14f81b5d6f9ea1d78e4c78582cb2"),
  jacket_leather_black: u("9bc0d2a43bfabf26500a385ac782bb3bc69d92a1143ac57be86759c91ff34f50"),
  coat_camel: u("d18ddd4e298e6ba77510da5cfaa4ad112e0ab55c247726e90d9222e0532f81d8"),
  // footwear
  sneakers_white: u("320881882322c845df931b0346ea09b9006bf9480fdf880e7f503c799d38ab67"),
  leathersneakers_brown: u("0f93cb7d3cf16949ad077de6a6757d9c71f9c1212ed75b3f47d01715e3dc58b7"),
  loafers_brown: u("c9096d3974f59c14626d2768382d38f0d015f1f7039f3ababe4e859be8bcc351"),
  oxford_black: u("9c9f60f30d1dab3b114f8c6456e40daa935a13cb389d6c94d78a812bbd297647"),
  heels_nude: u("d3c061ff67e7d26f9e8bef9769266f236f3d83d09e587797ef1d820d3a27b6cf"),
  boots_brown: u("d4ced61328f4130dde88e235c6ee8a61cacaf8edd8b9626fe487f13151aca82a"),
  sandals_tan: u("93fb95e1fd84d559a1e4a5a142e98742ed03b22c0fcde605aae8df8ed55a7ec2"),
  sneakers_black: u("cfe5ec2562a03ed002d0728085e4da840e2ede964755c6c725d7f01e18d5065b"),
  loafers_black: u("3f9b334314d1487c5e5256951e2401a64626416b2e1450ddf97d97271b6b46eb"),
  boots_black: u("2259ffc9e4fd64b534ba5fd65a3032da22fe94f7d8548be09d817eb651353862"),
  // accessories
  belt_brown: u("63b06f490f872880611d1863ada4715aaea6de2c3ba67adb7af369882290834e"),
  belt_black: u("e2d3882a2d285377d7126b51170c6ad5762382ef8851a59b00428f22af7e8c53"),
  watch_gold: u("67f2f1ee586eace1867ff77a10323b32ac18afbe68e57ce1665915fa34ee4f8b"),
  watch_silver: u("b43f9a9a116919eeebfced452e3394e022debf69a0c745ac80334660f461b093"),
  watch_black: u("89794c8d6da916270b4660b1e5316f0d73a2919a279d137205dfee268da35d0f"),
  necklace_gold: u("a262455cf3a97064af4a3fe20d5816c0dd40d2a208c75355e89fa9a6fdc420ee"),
  necklace_silver: u("587ca3a50f37a382a486742b25dd5875ec3e1c919daff72e56bb39d64c60cabc"),
  earrings_gold: u("391b9a64fd392fd830d6dd439d500efd3087267209507a6110994d2ffc7b7bbb"),
  earrings_silver: u("3633d5f981a6fd4c54165f6e5b48d9ef0112555dfad9a9f0be56034168ab1595"),
  bracelet_gold: u("709473cd78c635af1ae78ecc8c5b0a48f42f91e90201b9aeba9f537900ff7145"),
  bracelet_silver: u("b069dba0078352fc39ace9a48c7c59f9a82bb74746769ff509c9c1f63230af21"),
  sunglasses_tortoise: u("a4a2febd82f1b349efa51753404b21329759ed416c303b1a4e6cc028e4df5395"),
  sunglasses_black: u("29374009f0f31468c59630ebffcd5fcc839aec8ea0967cc01db24450e0e6bf24"),
  bag_tan: u("5c6e0ef19374f15ee04afc1f6aefc4cfd02ebad37fd63c88765af7b500bd36ed"),
  scarf_silk: u("e41f011d047f8f053c9ca3cd969e0fd238a7240019f6dab5419927453cb910d5"),
  // demo-only global-fashion example (THE PIECE landing rotation)
  dress_ankara_print: u("55e1bca75871036c37db9e4dd598f58edfedff5fe768906459bc80cac85b8859"),
};

// Atmospheric editorial imagery for empty states & HOME entry cards
export const SCENE = {
  wardrobe: u("10091da8d22329dc817c2ccf841f61c946101c75c9c68514cadf154369dbc241"),
  savedLooks: u("d4230c634a42ad794af4c0b51189cd92ee82782d3ba23c2cd4aa33772a8badb3"),
  myHome: u("4a7488669bfd8ffcb31ad8408ac9adacbe965a82ed634269b3093a810c0c9b24"),
  roomCard: u("8ca5f9121024e39860127b2912f630b11ec106d9908176efe5a5086989d53585"),
};

// ---- colour family classification -------------------------------------------
function hexToHsl(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "");
  if (!m) return null;
  let r = parseInt(m[1], 16) / 255, g = parseInt(m[2], 16) / 255, b = parseInt(m[3], 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = ((g - b) / d + (g < b ? 6 : 0));
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
  }
  return { h, s, l };
}

const NAME_FAMILY = [
  [/(off.?white|ivory|cream|ecru|chalk|snow)/, "white"],
  [/(charcoal|graphite|slate|gunmetal)/, "grey"],
  [/(grey|gray|ash|silver|dove|smoke)/, "grey"],
  [/(navy|midnight|indigo)/, "navy"],
  [/(denim|cobalt|sky|azure|teal|blue)/, "blue"],
  [/(olive|khaki|sage|moss|forest|emerald|hunter|green)/, "olive"],
  [/(chocolate|espresso|coffee|mocha|walnut|brown)/, "brown"],
  [/(tan|camel|cognac|caramel|toffee|hazel)/, "tan"],
  [/(beige|sand|stone|oatmeal|taupe|nude|greige|biscuit|wheat|linen)/, "beige"],
  [/(burgundy|maroon|wine|oxblood|merlot)/, "brown"],
  [/(rust|terracotta|orange|amber|copper)/, "tan"],
  [/(blush|rose|pink|salmon)/, "pink"],
  [/(lilac|lavender|plum|purple|violet|mauve)/, "purple"],
  [/(mustard|gold|yellow|ochre)/, "gold"],
  [/(red|crimson|scarlet|cherry)/, "red"],
  [/(black|jet|onyx|ink)/, "black"],
  [/(white)/, "white"],
];

export function colourFamily(item) {
  const text = `${item.color_name || ""} ${item.name || ""}`.toLowerCase();
  for (const [re, fam] of NAME_FAMILY) if (re.test(text)) return fam;
  const hsl = hexToHsl(item.color_hex);
  if (!hsl) return "neutral";
  const { h, s, l } = hsl;
  if (s < 0.14) {
    if (l > 0.78) return "white";
    if (l < 0.22) return "black";
    return "grey";
  }
  if (h < 20 || h >= 345) return l < 0.35 ? "brown" : "red";
  if (h < 45) return l < 0.4 ? "brown" : "tan";
  if (h < 70) return "gold";
  if (h < 160) return "olive";
  if (h < 200) return "blue";
  if (h < 255) return l < 0.35 ? "navy" : "blue";
  if (h < 300) return "purple";
  return "pink";
}

// ---- subcategory detection ---------------------------------------------------
function groupOf(item) {
  const g = (item.group || item.slot || "").toLowerCase();
  if (["tops", "bottoms", "dresses", "outerwear", "shoes", "bags", "accessories"].includes(g)) return g;
  const c = `${item.category || ""} ${item.name || ""}`.toLowerCase();
  // global / cultural garments → closest visual group
  if (/(agbada|sherwani|haori|bisht|kimono jacket|kimono coat)/.test(c)) return "outerwear";
  if (/(saree|sari|lehenga|abaya|kaftan|caftan|boubou|kanzu|thobe|thawb|dishdasha|jalabiya|jellaba|djellaba|kimono|yukata|hanbok|qipao|cheongsam|gomesi|kanga dress|robe|gown)/.test(c)) return "dresses";
  if (/(kurta|kurti|dashiki|kameez|salwar|dupatta|tunic|kaftan top|ankara top|kitenge top)/.test(c)) return "tops";
  if (/(dress|gown|jumpsuit|romper)/.test(c)) return "dresses";
  if (/(shoe|sneaker|loafer|heel|boot|sandal|oxford shoe|pump|trainer|brogue|derby|mule|espadrille)/.test(c)) return "shoes";
  if (/(trouser|jean|chino|cargo|skirt|short|pant|slack|legging|salwar|palazzo)/.test(c)) return "bottoms";
  if (/(blazer|jacket|coat|overcoat|parka|trench|overshirt)/.test(c)) return "outerwear";
  if (/(bag|tote|clutch|purse|handbag|backpack)/.test(c)) return "bags";
  if (/(belt|watch|necklace|earring|bracelet|ring|sunglass|glasses|scarf|tie|jewell|headwrap|gele|turban|hat|cap)/.test(c)) return "accessories";
  return /(shirt|tee|t-shirt|polo|blouse|knit|sweater|jumper|top|cardigan|hoodie)/.test(c) ? "tops" : "tops";
}

// Returns a curated asset URL for a recommended piece, or null (caller falls back).
export function assetForItem(item) {
  if (!item) return null;
  const g = groupOf(item);
  const text = `${item.name || ""} ${item.category || ""} ${item.icon || ""}`.toLowerCase();
  const fam = colourFamily(item);
  const A = ASSET;

  if (g === "shoes") {
    if (/(sneaker|trainer|tennis|court)/.test(text)) {
      if (fam === "black") return A.sneakers_black;
      if (["brown", "tan", "beige"].includes(fam)) return A.leathersneakers_brown;
      return A.sneakers_white;
    }
    if (/(loafer|moccasin|driver|slip.?on)/.test(text)) return fam === "black" ? A.loafers_black : A.loafers_brown;
    if (/(oxford|brogue|derby|dress shoe|wingtip|monk|lace.?up)/.test(text)) return A.oxford_black;
    if (/(heel|pump|stiletto|court shoe)/.test(text)) return A.heels_nude;
    if (/(boot|chelsea|chukka)/.test(text)) return fam === "black" ? A.boots_black : A.boots_brown;
    if (/(sandal|slide|espadrille|mule)/.test(text)) return A.sandals_tan;
    // generic shoe fallback
    if (fam === "black") return A.oxford_black;
    if (["brown", "tan", "beige"].includes(fam)) return A.loafers_brown;
    return A.sneakers_white;
  }

  if (g === "tops" || g === "dresses") {
    if (g === "dresses" || /(dress|gown|slip|saree|sari|lehenga|abaya|kaftan|caftan|boubou|kanzu|thobe|thawb|dishdasha|jalabiya|djellaba|kimono|yukata|hanbok|qipao|cheongsam|gomesi|robe)/.test(text)) {
      if (/(jumpsuit|romper|boiler)/.test(text)) return A.jumpsuit_olive;
      return A.dress_black;
    }
    if (/(polo)/.test(text)) return A.polo_navy;
    if (/(blouse|camisole|cami|tunic|kurta|kurti|dashiki|kameez)/.test(text)) return A.blouse_ivory;
    if (/(knit|sweater|jumper|cardigan|pullover|turtleneck|roll.?neck)/.test(text)) return A.knit_beige;
    if (/(oxford|button.?down|dress shirt)/.test(text)) return fam === "white" ? A.shirt_white : A.oxford_blue;
    if (/(shirt|overshirt)/.test(text)) {
      if (["blue", "navy"].includes(fam)) return A.oxford_blue;
      if (["beige", "cream", "tan"].includes(fam)) return A.blouse_ivory;
      return A.shirt_white;
    }
    if (/(tee|t-shirt|t shirt|crew|tank|henley|vest)/.test(text)) {
      return ["navy", "blue"].includes(fam) ? A.polo_navy : A.tshirt_white;
    }
    // generic top — colour-aware
    if (["navy", "blue"].includes(fam)) return A.polo_navy;
    if (["beige", "cream", "tan"].includes(fam)) return A.knit_beige;
    return A.tshirt_white;
  }

  if (g === "bottoms") {
    if (/(jean|denim)/.test(text)) return A.jeans_blue;
    if (/(cargo)/.test(text)) return A.cargo_khaki;
    if (/(skirt)/.test(text)) return A.skirt_black;
    if (/(short)/.test(text)) return A.shorts_stone;
    if (/(chino)/.test(text)) return fam === "olive" ? A.chinos_olive : A.chinos_beige;
    // trousers / slacks / pants
    if (fam === "olive") return A.chinos_olive;
    if (["beige", "tan", "brown"].includes(fam)) return A.chinos_beige;
    if (fam === "blue") return A.jeans_blue;
    return A.trousers_charcoal;
  }

  if (g === "outerwear") {
    if (/(blazer|suit jacket|sport coat|sherwani)/.test(text)) return A.blazer_navy;
    if (/(coat|overcoat|trench|topcoat|parka|agbada|bisht|kimono|haori|robe)/.test(text)) return A.coat_camel;
    if (/(leather|biker|moto|bomber|denim jacket|jacket|overshirt)/.test(text)) return A.jacket_leather_black;
    return A.blazer_navy;
  }

  if (g === "bags") return A.bag_tan;

  // accessories — colour/metal aware
  const metalText = `${item.color_name || ""} ${item.name || ""} ${item.material || ""}`.toLowerCase();
  const isSilver = /(silver|steel|stainless|platinum|white gold|chrome|rhodium|gunmetal|pewter)/.test(metalText)
    || (/(watch|necklace|earring|bracelet|bangle|chain|ring|pendant)/.test(text) && ["grey", "black"].includes(fam) && !/gold|brass/.test(metalText));
  const isBlack = fam === "black" || /\bblack\b/.test(metalText);
  if (/(belt)/.test(text)) return (isBlack || ["grey", "navy"].includes(fam)) ? A.belt_black : A.belt_brown;
  if (/(watch)/.test(text)) {
    if (/(leather|brown|tan|cognac)/.test(metalText) && !isSilver) return A.watch_gold;
    if (isBlack) return A.watch_black;
    if (isSilver) return A.watch_silver;
    return A.watch_gold;
  }
  if (/(necklace|pendant|chain)/.test(text)) return isSilver ? A.necklace_silver : A.necklace_gold;
  if (/(earring|stud|hoop)/.test(text)) return isSilver ? A.earrings_silver : A.earrings_gold;
  if (/(bracelet|bangle|cuff)/.test(text)) return isSilver ? A.bracelet_silver : A.bracelet_gold;
  if (/(ring)/.test(text)) return isSilver ? A.bracelet_silver : A.bracelet_gold;
  if (/(sunglass|glasses|eyewear|frames|shades)/.test(text)) return (isBlack || ["grey", "navy", "blue"].includes(fam)) ? A.sunglasses_black : A.sunglasses_tortoise;
  if (/(scarf|shawl|wrap)/.test(text)) return A.scarf_silk;
  if (/(tie|pocket square|bow)/.test(text)) return A.scarf_silk;
  if (/(bag|clutch|tote|purse)/.test(text)) return A.bag_tan;
  return null;
}


// Context-aware MOIRÉ FINDS resolver: turns a colour recommendation for a given
// match-category into a realistic GARMENT (type + realistic asset), driven by the
// chosen personality and occasion — never defaulting to formalwear.
const _FORMAL_OCC = /(work|formal|wedding|business|office|interview|gala|black.?tie)/i;

export function recommendationGarment(matchCategory, personality, occasion) {
  const cat = (matchCategory || "").toLowerCase();
  const p = (personality || "classic").toLowerCase();
  const formal = _FORMAL_OCC.test(occasion || "");

  if (/shoe/.test(cat)) {
    if (p === "classic" || formal) return { label: "Loafers", category: "loafers" };
    if (p === "bold" || p === "surprise") return { label: "Statement Sneakers", category: "sneakers" };
    return { label: "Leather Sneakers", category: "leather sneakers" };
  }
  if (/jacket/.test(cat)) {
    if (p === "bold" || p === "surprise") return { label: "Streetwear Jacket", category: "jacket", form: "street" };
    if (p === "classic" || formal) return { label: "Tailored Blazer", category: "blazer", form: "street" };
    return { label: "Overshirt", category: "jacket", form: "street" };
  }
  if (/accessor/.test(cat)) {
    return { label: "Accessory", category: "bag" };
  }
  if (/(trouser|pant|bottom|skirt|jean|denim|chino|cargo|slack|legging|palazzo)/.test(cat)) {
    if (/skirt/.test(cat)) {
      if (p === "surprise") return { label: "Maxi Skirt", category: "skirt", form: "skirt_maxi" };
      if (p === "bold") return { label: "Denim Skirt", category: "denim skirt", form: "skirt_denim" };
      if (p === "modern") return { label: "Pleated Skirt", category: "skirt", form: "skirt_pleated" };
      return formal ? { label: "Tailored Skirt", category: "skirt", form: "skirt_pleated" }
                    : { label: "Pleated Skirt", category: "skirt", form: "skirt_pleated" };
    }
    if (/(jean|denim)/.test(cat)) return { label: "Denim Jeans", category: "jeans", form: "jeans" };
    if (formal || p === "classic") return { label: "Tailored Trousers", category: "trousers", form: "trousers_tailored" };
    if (p === "modern") return { label: "Wide-Leg Trousers", category: "trousers", form: "trousers_wide" };
    if (p === "bold" || p === "surprise") return { label: "Denim Jeans", category: "jeans", form: "jeans" };
    return { label: "Relaxed Trousers", category: "trousers", form: "trousers_wide" };
  }
  // "Shirt / Top" and "Complete Look" — top-led, context not formal by default
  if (p === "surprise") return { label: "Flowing Piece", category: "dress", form: "gown" };
  if (formal || p === "classic") return { label: "Contemporary Blouse", category: "blouse", form: "blouse" };
  if (p === "modern") return { label: "Fine Knit", category: "knit sweater", form: "knit" };
  return { label: "Relaxed Tee", category: "t-shirt", form: "tee" };
}

// colour-accurate garment from the ways-to-wear library (nearest family + form)
export function wwAsset(rec, form) {
  const set = ASSET_WW[wwFamily({ color_name: rec.color_name, color_hex: rec.color_hex })] || ASSET_WW.ivory;
  return set[form] || set.tee || null;
}

// Returns {label, src, swatchHex} — colour-ACCURATE garment for a recommendation.
export function recommendationAsset(rec, matchCategory, personality, occasion) {
  const g = recommendationGarment(matchCategory, personality, occasion);
  if (g.form) {
    const src = wwAsset(rec, g.form);
    if (src) return { label: g.label, src, swatchHex: rec.color_hex };
  }
  const item = { category: g.category, name: `${rec.color_name || ""} ${g.category}`,
                 color_name: rec.color_name, color_hex: rec.color_hex };
  return { label: g.label, src: assetForItem(item), swatchHex: rec.color_hex };
}

// Colour-accurate visual for THE PIECE / a detected garment (user photo wins upstream).
export function pieceAssetColourAccurate(a) {
  const cat = `${a.category || ""} ${a.item || ""}`.toLowerCase();
  let form = null;
  if (/(gown|dress|saree|sari|kaftan|caftan|abaya|thobe|thawb|kimono|hanbok|qipao|cheongsam|robe|boubou|jalabiya|lehenga|jumpsuit)/.test(cat)) form = "gown";
  else if (/(blouse|shirt|kurta|kurti|tunic|dashiki|kameez)/.test(cat)) form = "blouse";
  else if (/(tee|t-shirt|t shirt|tank|top|polo|crop|vest)/.test(cat)) form = "tee";
  else if (/(knit|sweater|jumper|cardigan|hoodie|pullover)/.test(cat)) form = "knit";
  else if (/(jacket|blazer|coat|bomber|overshirt|agbada|sherwani|trench|parka)/.test(cat)) form = "street";
  else if (/(denim skirt|jean skirt)/.test(cat)) form = "skirt_denim";
  else if (/(maxi skirt|long skirt|flowing skirt)/.test(cat)) form = "skirt_maxi";
  else if (/(skirt)/.test(cat)) form = "skirt_pleated";
  else if (/(jean|denim)/.test(cat)) form = "jeans";
  else if (/(trouser|pant|slack|chino|cargo|bottom|legging|palazzo)/.test(cat)) form = "trousers_tailored";
  if (form) {
    const src = wwAsset({ color_name: a.primary_color_name, color_hex: a.primary_color_hex }, form);
    if (src) return src;
  }
  return assetForItem({ category: a.category, name: `${a.primary_color_name} ${a.item}`,
                        color_name: a.primary_color_name, color_hex: a.primary_color_hex });
}

// ---- "Ways To Wear It" — one colour, MANY realistic garment forms -----------
// Each colour family carries the SAME colour across many silhouettes:
// tops/dresses (gown/tee/blouse/knit/street) + skirts (pleated/denim/maxi)
// + trousers (tailored/wide) + jeans — all colour-accurate with real fabric.
const ASSET_WW = {
  white:      { gown: u("a92d818c9aa13159e038f3d9df627b38fddc2360c4b3c77b284a684a2763832d"), tee: u("a742bc92117b452c00b1a1e153f7c15e5e705ff335a0253af1dc91eaf98e72d6"), blouse: u("b2945c8dca608f41bfb089f2dbe07c67f6b3c1f3d9ae14560ae616a8a7928a90"), knit: u("d779a3d30831ac683f3086397f962e58deb3566f332bf2a35a65263db3634882"), street: u("8d65724b29bd485b292895cc80654a9c00c8906682e21712fecded2c531edb2c"), skirt_pleated: u("afe1c66cc3f3182682dd5c44c1df5eac2e1d5bf79704ebe2d758393bb4fa3e09"), skirt_denim: u("e425e552869781eb9d6af19e757f1971ca05dd24a37d28b410899401eeaea1bf"), skirt_maxi: u("3b833523a1f98e09ed36de286a8001488c4ac1ec3ab9a90c711cec9f2af5a745"), trousers_tailored: u("b0f44329a779483ac401d5ecb90ee0c956cb4163d49b27c4ced890232236127f"), trousers_wide: u("7d497d28d94aace697411854982006817357345b9a7847bf731f672fa5792ec3"), jeans: u("ac3e8b2fd14625b865608e867fe1061f9896a070ebb68777b6a922a652efe7a4") },
  ivory:      { gown: u("f3dac4ddcf07ae694d1287bc8a8575302de2ef54a5ff4daf07836fc06bcfa202"), tee: u("c7ac2d859e8dbfea64b1dce94e41fdd931abad53141d20cfd3909222910b2590"), blouse: u("c8dcad6914d5678b4b88df4101f07948b94d4ccf46f358ac93a6ec8fcaac5128"), knit: u("40b0b753d78ea7ed5ed4abbedf40249014b10a4d263e1eac61c17d69e363f4f6"), street: u("1e71e3c05e2e4cfda2210c7c4ebdf35400c5df263c499794ddbd1965dc3bfc46"), skirt_pleated: u("3dd306284610b8a78b709c19b0ec9d5cd01fdf5678b18e9af3675a059103523e"), skirt_denim: u("04e7ffd9f453106608e20ecc205d28f08ce5df6015cc6e07e76893a3f505a764"), skirt_maxi: u("aca5a473289539738f069cba3c75a7c26bb9372d84771b0059ac624c31fdb8a8"), trousers_tailored: u("82518118dc3848e6555d19828fa762f412dd9b9e4e7ddd9374a7f0990e43a914"), trousers_wide: u("e6c26b3957da6392c4ead1cf0dba815257c55a20cdabca13cbe8589cc82b62ce"), jeans: u("7bbe60e4ddf663d7b4aa494171a6e509b61e57e6328136195afc0e0c5db88d2a") },
  powderblue: { gown: u("47dbfd1f0890d4a162348646ade3bcc326dbbc2972b851ebf37bd9a723ef3657"), tee: u("f0c73d4a2876692b2ea5ee468a043932fc3d5bda4943fec98784c9730dc6b07a"), blouse: u("63399950bf61215b47a9a14ea941fb2daa12ba3949e19af8d4db6dafcacdaf1a"), knit: u("920e84c9481cdcec69408c1debe482bf45b92d1ee246dcf3761ba4509ebfb0ba"), street: u("f3128d41e521df304c99bdc0de473b69d1bdab4db2dac0d13d3b9f5fe1844a14"), skirt_pleated: u("0de34cebe6098d541a092d0ebce600dd008729102b93fdb4ed5ded744bf37e85"), skirt_denim: u("6c27a21a95349f249ccb2490658437c85fae7f5632d0a397610c03d508b12bdf"), skirt_maxi: u("56fcf89adcfc5a54708f7d1d9cb9ba7e317249fe11fbe519bc1926659448abe1"), trousers_tailored: u("a83137bf5c8805b95445dc7b7a855f1d980b128108543d93aee23d57caa6a9dd"), trousers_wide: u("15ea2b9547642b2e2de2facfbdcafceb37b56fe215580cef2366c048a4ddba79"), jeans: u("cda5131b9c15f6b538ee2c15a8d5221beb6e468d17ca1af2e7b6492d835ab15e") },
  blush:      { gown: u("c1af4cee3b7dcb96850de5316d82e87ff56aaa6bcafb95663f6fc414115c901e"), tee: u("91413a1f7f74bbdb5a385c92e74057ff839abbf0439a1b7696fb2f51c4580bb7"), blouse: u("4c1b38c6d27b3527704e5fdb73ea30493d9802526ebc623241e1b96e5ef752af"), knit: u("ad4d22c028dc9b5c1ccc01fb3c802d1d3f539f11e6c9103e91649e894e5d86d5"), street: u("b619dac0feed7c02abf1df7dc6c8af6e3769a0b5e323d07ccb09496ee11332ca"), skirt_pleated: u("53c0a7f991431016b32df5f486ec85c0b86a2df48ba63b0d49cb21b0cca5fb50"), skirt_denim: u("e627891a8b3bc6635d5781954ab1822fa487f59f2725712e7254a8d86dcdfe7b"), skirt_maxi: u("895f0fb549f093768992267fd5c3e8236b0ca277c93af2a91469fb80abc29e2a"), trousers_tailored: u("90baa939f34811736a1b60549b5deba24f86a6a7a8ffe5f68ebfeb4773295419"), trousers_wide: u("d89de73c14705f402587ff31861c3fabd180ba3be14ff5a007f86b13c1f4df15"), jeans: u("ef227ad57fe0aaa5ae8f4193d65f1b88bf95d0ad402f7290caa8ebfc767b5619") },
  sage:       { gown: u("7b87214237d8d02e624a9ad42bab782d894bb4577624c698d0b7630b902842cf"), tee: u("b9f45d7bcc73fc28476f67c086c01ceff5a7e4d2140e91d6e36de99f6a4e73b1"), blouse: u("94f184ac0432e1e81297b907461411aaee9a9545e3b69d957c9f4274ffd0c9a4"), knit: u("ab25d18c807188e1dea37b637f3af766c83dbe17d0529fd0fb47cc42b9cde41a"), street: u("f9d015c502b38a6f7d6ce706ec698b5b12834367883cb707adbd9057273c749e"), skirt_pleated: u("18999b8dfafdc21086e5593564af6f21f32b364e8bf213a1378b4557db28a9d4"), skirt_denim: u("e27199ccad847b5fab301f39f1987a433c34b927ba90e41cb334fe2b9071e94f"), skirt_maxi: u("2387dfcbdf7076f49ef0f98a44aefeeaf17d6e9e0028c6841072ebc7f3ed4324"), trousers_tailored: u("d30967564fbf333027b8f8c938c99ea88ff52d43df97a435220daa867c923105"), trousers_wide: u("dddaeb827bf62fc7ae6930965492df95463656f4ab5f7643bacebaa38a1bffdb"), jeans: u("d95643ca0549f88b16feb8ed009f685d57dceda334e8f8a2e2595f23456b9780") },
  navy:       { gown: u("ab231ad85dd3189590dc1d558f75bd026905a404d0a34ee9dc2e73c11be2eeff"), tee: u("d0a568be71fda853510f53ddc611340df4f9f3b8caa1ee7fa05d804785ea2a10"), blouse: u("f613c5f5090d8fb7ee7eb68b79664ce6d7d17b6f862b3df6f056cfd37cae133e"), knit: u("eb8d64247fa38dc1160c7be0b3ec344a74052e24cdd4204f64eed0fd6d2d68aa"), street: u("5419662f2c2ad324e7054c18a54f724578f5357b775a4941776589aea9f838fe"), skirt_pleated: u("d26cd8c7b3b158061ba70b8eadf6d55db408fcb08a1db8d690ee0579bfc80694"), skirt_denim: u("29f0ca76a85257e22ef55d119db93cc517a0ad11cf5031178ea3187e17b62ebd"), skirt_maxi: u("fde29f43fad3db61025c9b28b4e4962015cc2af5047358025c5db3d64a66ef7f"), trousers_tailored: u("94ab9602686c42404d93ab60a3c1c7a413e3e5f0bf2150eb39d577bc2c64bd92"), trousers_wide: u("b0cddc465a0e38bb30dfa6fe1dd364224901a4db5ac64fef7d90dfe014fc1af5"), jeans: u("e86301a4906ac40f27f3040fab1b629930e60192ee56f5ca9b297f551501ba6d") },
  charcoal:   { gown: u("ddbba60329b011340229a8c22a92b349bc67c69f00531a8e0f63c9001dc67c51"), tee: u("795e4296f3f16eaf2d2a7bd7f00fe79f2ab8bb7627fdb7ca5ca6e30c21ca3675"), blouse: u("954847b4142aa7e700e7b193bf91d6ce94de4ec12ed79199ae3fbb9a6f59ab1c"), knit: u("b58970161204cce88b94360590d97ddf322c8f692d98baf3e9383c35e79f3c5b"), street: u("1579512e57d0e9733c9619bea3cf8fcf77ac69031227c4d7d21ff17ff0c18c3f"), skirt_pleated: u("a4399ba6867c2ca2b7d708d432008c04193c1fb0b66f80a327e0d0bf13392084"), skirt_denim: u("6314f5988924e2031d8a4f6eb698eccc6372816cdab839a26c087c8e55d0f051"), skirt_maxi: u("b7657a3e99ffcbf4325f23b69586e71713b2d29d6534091bb630f66815dcbe81"), trousers_tailored: u("e94f9353eee26744de3fc4000af6de0d05ee37d95c7317cb439df2136cbcd0da"), trousers_wide: u("9837b1979ca8bdae58a551d2bcbf99d98f658fcba3c426e6f6c389fcbf96f774"), jeans: u("77ebae5d4ac7f3a021a256fb1a73d364d0f59dea00e853f23c9bac12acbd63db") },
  camel:      { gown: u("ce1e7489e09c2e6d80d5bf3d3164b0c8cd1fae54ea85a4f8865ffd68fb2e8f83"), tee: u("5a74638e5ad08f8310be7a38111b0e44e42308421a4d20a5410453daf2ef06fe"), blouse: u("78d55173e8ec11d566be1bc83a884f9ed8efd9ea5ee254b4baa47576c0b00dd5"), knit: u("f0374f82159aba4e7de9b97d445ae3319b6b95d76b6fa3279a117732d4aa8f01"), street: u("73a7ba02b04fd873914da4b6005983f8f5c3afeb3714b83440a5e5c81f366e83"), skirt_pleated: u("db2c3d113f94090a74949577cbdd6c1dfa751247b74f50f336cdaa6833af875f"), skirt_denim: u("8877b6f13d16ec4d3cde6e047d697f591b29201ddae8f3efab3fab0f130b62fc"), skirt_maxi: u("d9965fabeca74c26cbeef5ce364b252b1fab02aeb219bc6f77d2ea46cdf5ea29"), trousers_tailored: u("c23f8e3a68a08b2c98b4efe4dd54743f05db1279976ba56ac4cddc881ba40ce6"), trousers_wide: u("9aab313af988806d56850601829a57fd8af88949fae7949e2cf66391becba2e5"), jeans: u("eefffef03dde50a284a12d4a4e964687767eedef19398204f1bb6c4c6d172170") },
};

// map a recommendation colour to the nearest "ways-to-wear" family
function wwFamily(item) {
  const fam = colourFamily(item);
  const text = `${item.color_name || ""}`.toLowerCase();
  if (/(ivory|cream|ecru|off.?white|oat)/.test(text)) return "ivory";
  if (fam === "white") return "white";
  if (["black", "grey"].includes(fam)) return "charcoal";
  if (fam === "navy") return "navy";
  if (fam === "blue") return "powderblue";
  if (["green", "olive"].includes(fam)) return "sage";
  if (["pink", "purple", "red", "burgundy"].includes(fam)) return "blush";
  if (["brown", "tan", "beige", "gold"].includes(fam)) return "camel";
  return "ivory";
}

// Human-readable label for every garment FORM in the WW library.
const FORM_LABELS = {
  gown: "Flowing Gown",
  tee: "Relaxed Tee",
  blouse: "Contemporary Blouse",
  knit: "Fine Knit",
  street: "Streetwear Layer",
  skirt_pleated: "Pleated Skirt",
  skirt_denim: "Denim Skirt",
  skirt_maxi: "Maxi Skirt",
  trousers_tailored: "Tailored Trousers",
  trousers_wide: "Wide-Leg Trousers",
  jeans: "Denim Jeans",
};

// Per-family CURATED sequence — each colour moves through a genuinely different
// mix of silhouettes (tops, dresses, skirts, trousers, denim) so "one colour,
// many ways" never feels like five near-identical garments. Combinations vary
// deliberately between colours.
const FAMILY_SEQUENCE = {
  white:      ["gown", "skirt_pleated", "tee", "trousers_wide", "blouse", "jeans"],
  ivory:      ["blouse", "skirt_maxi", "knit", "trousers_tailored", "tee", "skirt_denim"],
  powderblue: ["tee", "skirt_denim", "jeans", "blouse", "trousers_wide", "gown"],
  blush:      ["gown", "skirt_maxi", "blouse", "trousers_tailored", "knit", "jeans"],
  sage:       ["knit", "trousers_wide", "tee", "skirt_pleated", "jeans", "street"],
  navy:       ["blouse", "trousers_tailored", "gown", "jeans", "skirt_pleated", "street"],
  charcoal:   ["street", "trousers_tailored", "knit", "skirt_denim", "tee", "trousers_wide"],
  camel:      ["knit", "trousers_wide", "blouse", "skirt_maxi", "jeans", "gown"],
};

// Returns an array of {key, label, src, alt} — several ways to wear one colour,
// with silhouettes that genuinely change across the sequence.
export function waysToWear(rec) {
  const item = { color_name: rec.color_name, color_hex: rec.color_hex };
  const fam = wwFamily(item);
  const set = ASSET_WW[fam] || ASSET_WW.ivory;
  const seq = FAMILY_SEQUENCE[fam] || FAMILY_SEQUENCE.ivory;
  const cn = rec.color_name || "";
  return seq
    .map((form, idx) => ({
      key: `${form}-${idx}`,
      label: FORM_LABELS[form] || form,
      src: set[form],
      alt: `${cn} ${(FORM_LABELS[form] || form).toLowerCase()}`,
    }))
    .filter((x) => x.src);
}
